import React from 'react'
import PropTypes from 'prop-types'
import {
  TitleWrapper,
  Wrapper,
  CustomTitle,
  IconsWrapper,
  Icon,
  IconItem,
  DescriptionWrapper,
} from './IconList.style'

const IconList = ({ title, description, items }) => {
  return (
    <Wrapper>
      <TitleWrapper>
        <CustomTitle>{title}</CustomTitle>
      </TitleWrapper>
      <IconsWrapper>
        {items
          .filter((item) => item.icon)
          .map((item) => (
            <IconItem>
              <Icon dangerouslySetInnerHTML={{ __html: item.icon.code }} />
              {item.description}
            </IconItem>
          ))}
      </IconsWrapper>
      {description && (
        <DescriptionWrapper
          dangerouslySetInnerHTML={{
            __html: description.childMarkdownRemark.html,
          }}
        />
      )}
    </Wrapper>
  )
}

IconList.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      description: PropTypes.string,
    })
  ),
}

IconList.defaultProps = {
  items: [],
}

export default IconList
